import { Route, Routes } from "react-router-dom";
import About from "../pages/About/About";
import Account from "../pages/Account/Account";
import Benchmark from "../pages/Benchmark/Benchmark";
import Career from "../pages/Career/Career";
import CaseSummary from "../pages/CaseSummary/CaseSummary";
import TrilingualDictionary from "../pages/Dictionary/TrilingualDictionary";
import Help from "../pages/Help/Help";
import Home from "../pages/Home/Home";
import KnowledgeHub from "../pages/KnowledgeHub/KnowledgeHub";
import CenturyCatalysts from "../pages/LegalPages/CenturyCatalysts";
import Privacy from "../pages/LegalPages/Privacy";
import Refund from "../pages/LegalPages/Refund";
import Terms from "../pages/LegalPages/Terms";
import PageNotFound from "../pages/PageNotFound/PageNotFound";
import Reports from "../pages/Reports/Reports";
import Results from "../pages/Results/Results";
import Stats from "../pages/Stats/Stats";
import Translate from "../pages/Translate/Translate";
import Preapproval from "../pages/Preapproval/Preapproval";

const Router = () => (
  <Routes>
    <Route path="/" element={<Home />} />
    <Route path="/authorize/:firmSlug" element={<Preapproval />} />
    <Route path="/help" element={<Help />} />
    <Route path="/benchmark" element={<Benchmark />} />
    <Route path="/stats" element={<Stats />} />
    <Route path="/about" element={<About />} />
    <Route path="/search" element={<Results />} />
    <Route path="/privacy" element={<Privacy />} />
    <Route path="/refund" element={<Refund />} />
    <Route path="/terms" element={<Terms />} />
    <Route path="/century-pricing" element={<CenturyCatalysts />} />
    <Route path="/careers" element={<Career />} />
    <Route path="/my-account" element={<Account />} />
    <Route path="/dictionary" element={<TrilingualDictionary />} />
    <Route path="/reports" element={<Reports />} />
    <Route path="/translate" element={<Translate />} />
    <Route path="/summary/*" element={<CaseSummary />} />
    <Route path="/standard_casenumber/*" element={<CaseSummary />} />
    <Route path="/knowledge-hub" element={<KnowledgeHub />} />
    <Route path="/knowledge-hub/:slug" element={<KnowledgeHub />} />
    <Route path="*" element={<PageNotFound />} />
  </Routes>
);

export default Router;
